import Flickity from 'flickity'
import isSiteInMobileMode from '../../js/modules/mt-isSiteInMobileMode.js'
import isSiteInDesktopMode from '../../js/modules/mt-isSiteInDesktopMode.js'

export default function () {
    $(document).ready(function () {

        function is_touch_device() {
            return 'ontouchstart' in window        // works on most browsers
                || navigator.maxTouchPoints;       // works on IE10/11 and Surface
        }

        // if the browser is IE9 or below, bail on all these carousels using Flickity V2 as it's not supported
        if (!$('html').hasClass('lt-ie10')) {
            if ($('.main-carousel').length) {
                // element argument can be a selector string
                //   for an individual element
                var flkty = new Flickity('.main-carousel', {
                    // options
                    imagesLoaded: true,
                    prevNextButtons: false,
                    cellSelector: '.carousel-cell',
                    dragThreshold: 30
                })
            }
            if ($('.super-carousel').length && !is_touch_device()) {
                $('.super-carousel').addClass('super-carousel--default')
                // element argument can be a selector string
                //   for an individual element
                var flkty = new Flickity('.super-carousel', {
                    // options
                    imagesLoaded: true,
                    prevNextButtons: true,
                    cellSelector: '.carousel-cell',
                    pageDots: false,
                    wrapAround: true,
                    arrowShape: 'M41.638 63.32H86.02c2.234.09 4.403-.757 5.983-2.337s2.427-3.75 2.335-5.98v-8.378c.046-2.95-1.537-5.686-4.118-7.117-1.197-.614-2.536-.897-3.88-.82H41.66l.7-.82c5.998-5.997 11.796-11.995 17.853-17.853 1.644-1.562 2.574-3.73 2.574-5.998 0-2.267-.93-4.435-2.573-5.997-1.678-1.5-3.198-3.18-4.797-4.778-3.16-3.02-8.135-3.02-11.296 0C30.19 17.222 16.275 31.184 2.373 45.126c-3.17 3.278-3.17 8.477 0 11.755 2.22 2.14 4.36 4.36 6.538 6.54l34.947 35.045c1.563 1.607 3.708 2.513 5.948 2.513s4.386-.906 5.948-2.513l4.598-4.518C62.04 92.41 63 90.232 63 87.95c0-2.283-.962-4.46-2.65-5.998-5.957-5.985-11.954-11.982-17.992-17.994l-.72-.64z',
                    dragThreshold: 30
                })
            }
            if ($('.super-carousel').length && is_touch_device()) {
                $('.super-carousel').addClass('super-carousel--alternate')
                $('.super-carousel').addClass('superportals--alternate-theme')
            }
        } else {
            // else the browser is IE9 or below

            // fallback carousel for .main-carousel
            if ($('.main-carousel').length) {
                $('.main-carousel').each(function () {
                    const carousel = $(this),
                        slidesCount = carousel.find('.carousel-cell').length,
                        slides = carousel.find('.carousel-cell')

                    // constructing the little radio buttons to click between slides
                    carousel.append('<div class="iefallback-slideDots"></div>')
                    const slideDotsContainer = carousel.find('.iefallback-slideDots').first()
                    for (let count = 0; count < slidesCount; count++) {
                        slideDotsContainer.append('<button class="iefallback-slideDot"></button>')
                    }

                    const slideDots = slideDotsContainer.children()

                    // prime the initial selected state
                    slides.first().addClass('is-selected')
                    slideDots.first().addClass('is-selected')

                    // interaction code
                    slideDots.click(function () {
                        const thisDot = $(this),
                            thisDotNumber = thisDot.index()

                        slideDots.removeClass('is-selected')
                        thisDot.addClass('is-selected')
                        slides.removeClass('is-selected')
                        slides.eq(thisDotNumber).addClass('is-selected')
                    })
                })
            }
        }
    })
}
